
// Durée avant déconnection automatique suite à mauvais paramétrage
export const DURATION_RELOAD_APP = 5
